import { HttpService } from '@/infra/http'

export type TGetAcessoriosDisponiveisResponse = Array<{
  nome: string
  acessorios: Array<{
    nome: string
    idExterno: number
    metragem: string
  }>
}>

export class GetAcessoriosDisponiveisService extends HttpService {
  execute = async (idExternoBloco: number) => {
    return this.http.get<TGetAcessoriosDisponiveisResponse>(
      `/api/v2/Produto/bloco/${idExternoBloco}/acessorio/disponiveis`,
    )
  }
}
